module.exports = __webpack_public_path__ + "img/Andorra.44faf762.svg";